import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import LoadingIndicator from '../components/LoadingIndicator';
import '../styles/ManageRolesPage.css';

import ManageRoles from '../components/ManageRoles';
import ConfigExternalRoles from '../components/ConfigExternalUserRoles';
import ConfigRolesToMenu from '../components/ConfigRolesToMenu';

const ManageRolesPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Adjust the layout to stack panels vertically
  return (
    <div className="manage-roles-page">
      {loading && <LoadingIndicator isLoading={true} />}
      
      {error && <div className="error-message">{error}</div>}
      
      {/* Manage Roles Panel */}
     <ManageRoles />
      
      {/* Config External User Roles Panel */}
     <ConfigExternalRoles/>

      {/* Config Roles To Menu Panel */}
      <ConfigRolesToMenu />
    </div>
  );
};

export default ManageRolesPage;